import { ButtonList } from '@dixa/lib-shared-habla';
import { FloatingDiv } from 'articleEditor/components/floatingDiv/floatingDiv';
import { Popover } from 'articleEditor/components/popover';
import usePointHover from 'articleEditor/hooks/usePointHover';
import cx from 'classnames';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { Point } from 'lib-knowledge-document-structure/slate/package';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';

import s from './blockShortcutMenu.module.scss';
import { onSelectBlock } from './createShortcutPlugin';
import { actions, shortcutState } from './shortcut.store';

export function BlockShortcutMenu(): JSX.Element {
  const editor = useMyEditorRef();
  const { point, filteredBlocks, selectedBlockIndex, newLine } =
    useSnapshot(shortcutState);

  const floatingPoint = useMemo(() => {
    return newLine && point
      ? { path: [point.path[0]], offset: 0 }
      : (point as Point);
  }, [newLine, point]);

  const floatingProps = usePointHover({
    point: floatingPoint,
    floatingDivId: 'blockShortcutMenu',
  });

  return (
    <FloatingDiv id="blockShortcutMenu" floatingProps={floatingProps}>
      {floatingProps.isOpen && (
        <Popover>
          {filteredBlocks.length > 0 ? (
            <ButtonList>
              {filteredBlocks.map((block, index) => (
                <ButtonList.Item
                  className={cx(
                    selectedBlockIndex === index && s['shortcutItemSelected'],
                  )}
                  icon={block.icon}
                  key={block.type}
                  onClick={() => onSelectBlock(editor, block)}
                  buttonProps={{
                    onMouseDown(e) {
                      // Make sure the onClick here registers instead of the blur in the editor (which hides the menu)
                      e.preventDefault();
                      e.stopPropagation();
                    },
                    onMouseOver() {
                      actions.setIndex(index);
                    },
                  }}
                >
                  {block.label}
                </ButtonList.Item>
              ))}
            </ButtonList>
          ) : (
            <div className={s['blockMenuMessage']}>No&nbsp;results</div>
          )}
        </Popover>
      )}
    </FloatingDiv>
  );
}
